// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"ApiTokenScreen_buttonsContainer__1Cz7u","button":"ApiTokenScreen_button__MMDWD"};